import React, { useEffect, useState } from 'react';
import { BsCheck2Circle } from 'react-icons/bs';
import { useNavigate, useParams } from 'react-router-dom';
import { StartButton } from '../../../../Utils/saveButton';
import { useTypedSelector } from '../../../../../hooks/useTypeSelector';
import axios from 'axios';
import { globalEnv } from '../../../../../config/baseConfig';
import { useQuery } from 'react-query';
import LoadingAnimComponent from '../../../../Utils/LoadingAnimations/loadingAnimation';
import { templateCardType } from '../../CreateNewCampaign/selectTempate';

export const SelectTemplateInCampaign = () => {
	const { campaignId } = useParams();
	const [selectedTemplates, setSelectedTemplates] = useState<any[]>([]);

	const [emailTemplates, setEmailTemplates] = useState<EmailTemplateType[]>([]);
	type EmailTemplateType = {
		_id: number;
		name: string;
		pictureUrl: string;
	};

	const { ACCESS_TOKEN } = useTypedSelector((state) => state.auth);

	async function fetchSettingsData() {
		const config = {
			headers: {
				Authorization: 'Bearer ' + ACCESS_TOKEN
			}
		};
		const { data } = await axios.get(
			`${globalEnv.BASE_URL}/outreach/email-template/all`,
			config
		);
		return data;
	}

	const { data, isLoading, isError } = useQuery([], () => fetchSettingsData(), {
		keepPreviousData: true,
		refetchOnWindowFocus: false,
		staleTime: 5000
	});

	useEffect(() => {
		if (data != null) {
			setEmailTemplates(data);
		}
	}, [data]);

	const navigate = useNavigate();

	return (
		<>
			{isLoading ? (
				<LoadingAnimComponent />
			) : (
				<div className="pt-16 pl-18 dark:bg-gray-800">
					<div className="mt-5 w-full flex justify-center">
						<h3 className="block uppercase text-6xl tracking-wide text-gray-700 dark:text-gray-300 font-bold mb-2 px-3">
							Pick a template
						</h3>
					</div>
					<div className="mx-auto mt-5 pr-3">
						<div className="w-11/12 lg:w-fit  carousel p-4 bg-card-light border-border-light dark:bg-card-dark dark:border-border-dark  rounded-box mx-auto transition-all duration-500">
							{emailTemplates.length > 0 &&
								emailTemplates.map((item: any, index: number) => (
									<TemplateCard
										id={item._id}
										title={item.name}
										path={item.path}
										img={item.pictureUrl}
										index={index}
										isSelected={selectedTemplates.includes(item.path)}
										selectedTemplates={selectedTemplates}
										setSelectedTemplates={setSelectedTemplates}
									/>
								))}
						</div>
					</div>
					<div className="w-full flex justify-end mt-3 pr-3">
						<StartButton
							text="Next"
							isSaving={false}
							saveFunc={() =>
								navigate(
									`../outreach/campaign/${campaignId}/${selectedTemplates.join()}/send-email`
								)
							}
						/>
					</div>

					<div className="h-3"></div>
				</div>
			)}
		</>
	);
};

export function TemplateCard(props: templateCardType) {
	const addTemplate = () => {
		const templatesCopy = props.selectedTemplates.slice();
		templatesCopy.push(props.path);
		props.setSelectedTemplates(templatesCopy);
	};

	const removeTemplate = () => {
		const templatesCopy = props.selectedTemplates.slice();
		templatesCopy.splice(
			templatesCopy.findIndex((item) => item === props.path),
			1
		);
		props.setSelectedTemplates(templatesCopy);
	};

	return (
		<div className="carousel-item flex flex-col transition-all duration-700 h-3/5">
			<div
				className={`relative mx-3 overflow-hidden shadow-xl rounded-2xl max-w-xl `}
			>
				<img
					src={props.img}
					className={`object-cover h-[450px] w-64 rounded-2xl  ${
						props.isSelected && 'border-purple-600 border-4'
					}`}
				/>

				<div
					className="absolute inset-0 bg-gradient-to-t from-black/50 opacity-0 hover:opacity-100 transition-all duration-500 text-center  cursor-pointer"
					onClick={() => {
						props.isSelected ? removeTemplate() : addTemplate();
					}}
				/>

				{props.isSelected ? (
					<BsCheck2Circle
						size="120"
						className="absolute h-[50%] top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] text-purple-600  dark:text-primary text-center transition-all duration-500 opacity-100"
					/>
				) : (
					<BsCheck2Circle
						size="120"
						className="absolute h-[50%] top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] text-purple-600  mx-2 dark:text-primary text-center transition-all duration-500 opacity-0 scale-0"
					/>
				)}
			</div>

			<h3 className="text-gray-600 dark:text-gray-200 text-lg mt-2 font-semibold mx-auto">
				{props.title}
			</h3>
		</div>
	);
}
